<div class="field mb-4 col-12">
  <app-amn-files-upload #amnFilesUploader (uploadingFiles)="onUpload($event)">
  </app-amn-files-upload>
</div>
